"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHeatPump = function IconHeatPump(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M41 8H7v11h34zM7 23v-3h34v3zM5 6v17a2 2 0 0 0 2 2h34a2 2 0 0 0 2-2V6zm33 6h-5v-1h5zm-8 0h2v-1h-2zM18.88 30.214 17.877 29l-.231.203a5.16 5.16 0 0 0-.883 6.478l.438.672.16.263a3.59 3.59 0 0 1-.527 4.25l1.137 1.087.216-.24a5.16 5.16 0 0 0 .545-5.869 6 6 0 0 0-.197-.327l-.365-.554-.16-.264a3.586 3.586 0 0 1 .868-4.485M23.684 29l1.001 1.214a3.586 3.586 0 0 0-.868 4.485l.16.264.364.554c.08.123.136.217.198.327a5.16 5.16 0 0 1-.545 5.868l-.216.24-1.138-1.087a3.59 3.59 0 0 0 .528-4.249l-.16-.263-.439-.672a5.162 5.162 0 0 1 .883-6.478zm6.792 1.214L29.476 29l-.232.203a5.16 5.16 0 0 0-.883 6.478l.439.672.16.263a3.59 3.59 0 0 1-.528 4.25l1.138 1.087.216-.24a5.16 5.16 0 0 0 .545-5.869 6 6 0 0 0-.197-.327l-.366-.554-.16-.264a3.586 3.586 0 0 1 .869-4.485",
    clipRule: "evenodd"
  })));
};

export { IconHeatPump, IconHeatPump as default };
